<section class="container sign-container reset-password-container">
	<img class="sign-in-background" src="../../../assets/img/{{themeService.theme}}/zp-lg-background.png" alt="">
	<section class="navbar-brand">
		<img src="../../assets/img/{{themeService.theme}}/{{themeService.theme == 'bluecoat' ? 'main-logo' : 'scd-logo'}}.png" alt="Company Logo" width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
	</section>
	<!-- <div class="sign-account" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
	<section class="container" [ngClass]="{'bluecoat-login-card': themeService.theme == 'bluecoat'}">
		<h1 class="serif-title" [ngClass]="{'nwr-color-title': themeService && themeService.theme == 'NWRTheme'}">Reset Your Password</h1>
		<p>Please get in touch with our customer service team who may be able to help you.</p>
		<div class="get-in-touch">
			<a href="mailto:help@zenplans.co.uk">
				<input type="submit" class="form-control btn btn-primary primary-default-btn get-in-touch"
					value="Get in touch" [ngClass]="{'nwr-theme-input': themeService.theme == 'NWRTheme'}">
			</a>
		</div>
		<!-- <div class="sign-account sign-account-mobile" [routerLink]="['/sign-up']">Don't have an account? Sign Up</div> -->
		<div class="back-login">
			<a [routerLink]="['/log-in']">Return to log in</a>
		</div>
	</section>
</section>
<app-footer></app-footer>	